import {SiteLinks} from "./site-links";
import {GtmSiteDetails} from "./gtm/gtm-site-details"

export class SiteDetails {
  supportName: string = '';
  supportNumber: string = '';
  unlimitedTerminology: string = '';
  emailDomain: string = '';
  footer: string = '';
  siteLinks: SiteLinks = new SiteLinks();
  toolboxName: string = '';
  loginPageUrl: string = '';
  logoPath: string = '';
  logoPathMobile: string = '';
  salesHotline: string = '';
  maxPasswordLength: number;
  gtmSiteDetails: GtmSiteDetails = new GtmSiteDetails();
}
